var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticStyle:{"margin-bottom":"50px"}},[_vm._v("路由变化的菜单组件")]),_vm._v(" "),_c('el-row',{attrs:{"gutter":40}},[_c('el-col',{attrs:{"xs":7,"sm":7,"md":6}},[_c('Sidebar2',{attrs:{"activeIdx":0}})],1),_vm._v(" "),_c('el-col',{attrs:{"xs":17,"sm":17,"md":18}},[_vm._v("\n      123\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b35e74de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/page2/side1.vue
// module id = null
// module chunks = 